import React from 'react';
import { Col, Row, Text } from 'components';
import { StyleSheet } from 'react-native';

const MSC_BLUE = '#004B8D';
const WARNING = '#F5A623';
const SUCCESS = '#1FA463';
const ERROR = '#E94A36';
const STEEL_GREY = '#E0E2E5';

interface SummaryMetricsProps {
  totalOrders: number;
  outForDelivery: number;
  delivered: number;
  issuesReported: number;
}

const SummaryMetrics: React.FC<SummaryMetricsProps> = ({
  totalOrders,
  outForDelivery,
  delivered,
  issuesReported,
}) => {
  return (
    <Col style={styles.summaryBar}>
      <Row justifyContent="center" alignItems="center" flex1>
        <Col style={[styles.metricCard, { backgroundColor: '#E6F2FF', borderColor: '#BFDBFE' }]} marginHorizontal={16}>
          <Text fontSize={32} bold style={{ color: MSC_BLUE }} textAlign="center">
            {totalOrders}
          </Text>
          <Text fontSize={12} semiBold style={{ color: MSC_BLUE + 'B3', textTransform: 'uppercase', letterSpacing: 0.5 }} textAlign="center" marginTop={8}>
            TOTAL ORDERS TODAY
          </Text>
        </Col>
        <Col style={[styles.metricCard, { backgroundColor: '#FFF8E6', borderColor: '#FDE68A' }]} marginHorizontal={16}>
          <Text fontSize={32} bold style={{ color: WARNING }} textAlign="center">
            {outForDelivery}
          </Text>
          <Text fontSize={12} semiBold style={{ color: WARNING + 'B3', textTransform: 'uppercase', letterSpacing: 0.5 }} textAlign="center" marginTop={8}>
            OUT FOR DELIVERY
          </Text>
        </Col>
        <Col style={[styles.metricCard, { backgroundColor: '#E6F7ED', borderColor: '#86EFAC' }]} marginHorizontal={16}>
          <Text fontSize={32} bold style={{ color: SUCCESS }} textAlign="center">
            {delivered}
          </Text>
          <Text fontSize={12} semiBold style={{ color: SUCCESS + 'B3', textTransform: 'uppercase', letterSpacing: 0.5 }} textAlign="center" marginTop={8}>
            DELIVERED
          </Text>
        </Col>
        <Col style={[styles.metricCard, { backgroundColor: '#FFEBE8', borderColor: '#FCA5A5' }]} marginHorizontal={16}>
          <Text fontSize={32} bold style={{ color: ERROR }} textAlign="center">
            {issuesReported}
          </Text>
          <Text fontSize={12} semiBold style={{ color: ERROR + 'B3', textTransform: 'uppercase', letterSpacing: 0.5 }} textAlign="center" marginTop={8}>
            LIVE OPEN ISSUES
          </Text>
        </Col>
      </Row>
    </Col>
  );
};

const styles = StyleSheet.create({
  summaryBar: {
    backgroundColor: 'white',
    borderBottomWidth: 1,
    borderBottomColor: STEEL_GREY,
    paddingHorizontal: 32,
  },
  metricCard: {
    paddingVertical: 12,
    paddingHorizontal: 24,
    borderRadius: 8,
    borderWidth: 1,
    minWidth: 180,
  },
});

export default SummaryMetrics;

